/** Before using this, check whether there's 'VITE_ENV' on Bitbucket => Repository Settings => Deployments Variables */
const isNotProduction = () => import.meta.env.VITE_ENV !== 'production';

const isNotStage = () => import.meta.env.VITE_ENV !== 'stage';

export { isNotProduction, isNotStage };
